import React from 'react';
import { array, number, oneOfType } from 'prop-types';
import { LuArrowRight } from 'react-icons/lu';
import { FormattedMessage } from '../../util/reactIntl';
import { propTypes } from '../../util/types';
import { userDisplayNameAsString } from '../../util/data';
import { NamedLink } from '../../components';
import ServiceCard from './ServiceCard';

import css from './SectionMoreServices.css';

const MAX_SERVICE_CARDS = 3;

// Figma 314:1976 "More services from {name}": up to three of the author's
// other services (the picked ones or the newest, see relatedListingsForPage)
// and an "All N services" link to the profile, where N is totalCount.
// Nothing renders when the author has no other services.
const SectionMoreServices = props => {
  const { services, totalCount, author } = props;
  const authorId = author?.id?.uuid;
  const shownCount = services ? services.length : 0;

  if (!authorId || shownCount === 0) {
    return null;
  }

  const count = totalCount ?? shownCount;

  const name = userDisplayNameAsString(author, '');
  const shown = services.slice(0, MAX_SERVICE_CARDS);

  return (
    <section className={css.root}>
      <div className={css.heading}>
        <h2 className={css.title}>
          <FormattedMessage id="SectionMoreServices.title" values={{ name }} />
        </h2>
        <NamedLink
          className={css.textLink}
          name="ProfilePage"
          params={{ id: authorId }}
          to={{ hash: '#services' }}
        >
          <FormattedMessage id="SectionMoreServices.allServices" values={{ count }} />
          <LuArrowRight className={css.arrow} aria-hidden="true" />
        </NamedLink>
      </div>
      <ul className={css.grid}>
        {shown.map((listing, index) => (
          <li className={css.item} key={listing.id.uuid}>
            <ServiceCard listing={listing} placeholderIndex={index} />
          </li>
        ))}
      </ul>
    </section>
  );
};

SectionMoreServices.defaultProps = {
  services: [],
  totalCount: null,
};

SectionMoreServices.propTypes = {
  services: array,
  // Every visible other service of the author; defaults to services.length
  totalCount: number,
  author: oneOfType([propTypes.user, propTypes.currentUser]).isRequired,
};

export default SectionMoreServices;
